const MAGIC_VALUE = '0x1626ba7e';
const MAGIC_VALUE_BYTES = '0x20c13b0b';
export { MAGIC_VALUE, MAGIC_VALUE_BYTES };
//# sourceMappingURL=signatures.js.map